module.exports = __webpack_public_path__ + "static/media/Region_20_Contest_Schedule_2026_2027_8_2_26.008ae851.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/26-27/Region_20_Contest_Schedule_2026_2027_8_2_26.pdf
// module id = 261
// module chunks = 0